// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularCategories_wrapper__CP8M4"};